export default __webpack_public_path__ + "static/media/New-Logo.21eecd85.svg";